module.exports = __webpack_public_path__ + "img/inbox.04bbe2de.svg";